// extracted by mini-css-extract-plugin
export default {"button":"_2RKNf_GxaJr223eO5bxwKS","inverted":"_3co-TALdmxOTzlpRwWFYBP","link":"-rildgBg6vyJdX-y9ZQ9f _2RKNf_GxaJr223eO5bxwKS"};